import React, { useEffect, useRef, useMemo } from "react";
import JsBarcode from "jsbarcode";

const OrderPage = ({ data, itemsPerPage = 24 }) => {
  const barcodeRefs = useRef([]);

  // Barcode configuration
  const barcodeOptions = useMemo(
    () => ({
      format: "code128",
      lineColor: "#000000",
      width: 2,
      height: 90,
      displayValue: true,
      fontSize: 12,
    }),
    []
  );

  // Expand variants based on quantities
  const expandedVariants = useMemo(() => {
    return data.flatMap((product) =>
      product.variants.flatMap((variant) =>
        Array.from({ length: variant.quantity }, (_, i) => ({
          ...variant,
          product_title: product.product_title,
          uniqueKey: `${variant.id}-${i}`,
        }))
      )
    );
  }, [data]);

  // Generate barcodes
  useEffect(() => {
    barcodeRefs.current.forEach((ref, index) => {
      if (ref && expandedVariants[index]?.laam_barcode) {
        try {
          JsBarcode(
            ref,
            String(expandedVariants[index].laam_barcode),
            barcodeOptions
          );
        } catch (error) {
          console.error("Barcode error:", error);
        }
      }
    });
  }, [expandedVariants, barcodeOptions]);

  // Calculate pages
  const totalPages = Math.ceil(expandedVariants.length / itemsPerPage);

  return (
    <div
      className="a4-barcode-sheets"
      style={{ width: "210mm", margin: "0 auto" }}
    >
      <style>
        {`
          @page {
            size: A4;
            margin: 0;
          }
          @media print {
            html,body {
             
              margin: 0 !important;
              padding: 0 !important;
             
              -webkit-print-color-adjust: exact;
            }
            .a4-page {
              width: 210mm;
              height: 297mm;
              page-break-after: always;
              padding: 5mm;
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              grid-auto-rows: 31mm;
              gap: 5mm;
            }
            .barcode-cell {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              border: 1px dotted #eee;
              padding: 1mm;
            }
            .product-name {
              font-size: 7pt;
              text-align: center;
            
              line-height: 1.2;
            }
            .variant-info {
              font-size: 6pt;
              
              text-align: center;
              margin-top: 1mm;
            }
          }
        `}
      </style>

      {Array.from({ length: totalPages }).map((_, pageIndex) => {
        const startIdx = pageIndex * itemsPerPage;
        const endIdx = startIdx + itemsPerPage;
        const pageItems = expandedVariants.slice(startIdx, endIdx);

        return (
          <div key={`page-${pageIndex}`} className="a4-page">
            {pageItems.map((variant, idx) => (
              <div key={variant.uniqueKey} className="barcode-cell">
                <div className="product-name">
                  {variant.product_title} | {variant.variant_title}
                </div>
                <div className="variant-info">{variant.laam_sku}</div>
                <svg
                  ref={(el) => (barcodeRefs.current[startIdx + idx] = el)}
                  style={{ width: "100%", height: "15mm" }}
                />
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default OrderPage;
// import React, { useEffect, useRef, useMemo } from "react";
// import JsBarcode from "jsbarcode";

// const OrderBarcodesPage = ({ data, itemsPerPage = 24 }) => {
//   const barcodeRefs = useRef([]);

//   const barcodeOptions = useMemo(
//     () => ({
//       format: "code128",
//       lineColor: "#000000",
//       width: 1.2,
//       height: 45,
//       displayValue: true,
//       fontSize: 10,
//     }),
//     []
//   );

//   const expandedVariants = useMemo(() => {
//     return data.flatMap((product) =>
//       product.variants.flatMap((variant) =>
//         Array.from({ length: variant.quantity }, () => ({
//           ...variant,
//           product_title: product.product_title,
//         }))
//       )
//     );
//   }, [data]);

//   useEffect(() => {
//     barcodeRefs.current.forEach((ref, index) => {
//       if (ref && expandedVariants[index]?.laam_barcode) {
//         JsBarcode(
//           ref,
//           String(expandedVariants[index].laam_barcode),
//           barcodeOptions
//         );
//       }
//     });
//   }, [expandedVariants, barcodeOptions]);
//   const totalPages = Math.ceil(expandedVariants.length / itemsPerPage);
//   return (
//     <div className=" d-flex flex-wrap gap-3">
//       {expandedVariants.map((variant, index) => (
//         <div
//           key={`${variant.id}-${index}`}
//           className=" border p-1 d-flex flex-column justify-content-between"
//         >
//           <div
//             style={{
//               width: "155px",
//               height: "150px",
//               boxSizing: "border-box",
//             }}
//           >
//             <p className="fontS">
//               {variant.product_title} "{variant.variant_title}"
//             </p>
//             <span className="fontS">{variant.laam_sku}</span>
//             <span>
//               <svg ref={(el) => (barcodeRefs.current[index] = el)}></svg>
//             </span>
//           </div>
//         </div>
//       ))}

//       <hr className="dotted-line" />
//       {/* <span className="fontS">
//         Print Date {new Date().toLocaleDateString("en-US")}
//       </span> */}
//     </div>
//   );
// };

// export default OrderBarcodesPage;
